import { render, staticRenderFns } from "./BringupsWeek.vue?vue&type=template&id=7642ef58"
import script from "./BringupsWeek.vue?vue&type=script&lang=js"
export * from "./BringupsWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports